export default {"src":"/_next/static/media/forest-checkmark-icon.7e205b43.svg","height":19,"width":23,"blurWidth":0,"blurHeight":0};